import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useCompanyTracking } from '@/hooks/useCompanyTracking';
import { TrackingSnippet } from './TrackingSnippet';
const COPY = {
    workspace: {
        heading: 'Visitor Tracking',
        description: 'Install this snippet on pages where this workspace captures leads.',
        label: 'Workspace tracking snippet',
    },
    campaign: {
        heading: 'Visitor Tracking',
        description: 'Install this snippet on pages where this campaign captures leads.',
        label: 'Campaign tracking snippet',
    },
};
export const TrackingPanel = (props) => {
    const { tracking, isLoading, error } = useCompanyTracking(props.clientCompanyId);
    const copy = COPY[props.scope];
    return (_jsxs("div", { className: "bg-slate-50 dark:bg-slate-700/30 rounded-xl p-6 border border-slate-200 dark:border-slate-600", children: [_jsx("h3", { className: "text-lg font-semibold text-slate-900 dark:text-white", children: copy.heading }), _jsx("p", { className: "text-sm text-slate-600 dark:text-slate-300 mt-1 mb-4", children: copy.description }), isLoading && (_jsx("div", { className: "h-20 rounded bg-slate-200 dark:bg-slate-600 animate-pulse" })), !isLoading && error && (_jsx("div", { className: "text-sm text-red-600 dark:text-red-400", children: error })), !isLoading && !error && tracking && (_jsx(TrackingSnippet, { TrackingId: tracking.TrackingId, ScriptUrl: tracking.ScriptUrl, WorkspaceId: props.workspaceId, CampaignId: props.scope === 'campaign' ? props.campaignId : undefined, label: copy.label }))] }));
};
